import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Divider } from "material-ui";
import { Paper, withStyles } from "@material-ui/core";

import { Tipografia } from "../../../../_common";

const styles = {
  textoEvento: { display: "flex", flexDirection: "column", height: "100%", width: "100%", padding: "8px 8px 0px 8px" },
  texto: { whiteSpace: "pre-line", paddingBottom: 5 },
  textoAnterior: { whiteSpace: "pre-line", paddingBottom: 8 },
  textoResponsavel: { whiteSpace: "pre-line", paddingBottom: 5 },
  divisor: { marginTop: "8px !important", marginBottom: "8px !important" },
  estiloCampo: { fontWeight: "bold" },
  estiloCard: { paddingBottom: 8 },
};

const TimeLineItemLogCadastro = ({ evento, index, isTimelineAtividades, classes }) => {
  const intl = useIntl();
  return (
    <Paper className={classes.textoEvento} zDepth={1} id="divTimeLine" elevation={isTimelineAtividades ? 0 : 1}>
      <Tipografia
        tipo="notaLegendas"
        cor="darkSecondaryText"
        className={classes.textoResponsavel}
        id={`lblResponsavel-${index}`}
      >
        {evento.responsavel}
      </Tipografia>
      <Tipografia className={classes.texto}>
        {evento.flLogEdicaoEmMassa
          ? intl.formatMessage({ defaultMessage: "Alteração em massa" })
          : intl.formatMessage({ defaultMessage: "Alteração" })}
      </Tipografia>
      {evento.nomeCampo && (
        <div className={classes.estiloCard}>
          <Tipografia tipo="notaLegendas" className={classes.texto}>
            <span className={classes.estiloCampo}>{evento.nomeCampo}</span>{" "}
            {intl.formatMessage({
              defaultMessage: "para",
            })}: {evento.novoValor}
          </Tipografia>
          <Divider className={classes.divisor} />
          <Tipografia tipo="notaLegendas" className={classes.textoAnterior}>
            {intl.formatMessage({ defaultMessage: "Antes registrado como" })}: {evento.valorAnterior}
          </Tipografia>
        </div>
      )}
      {evento.texto && <Tipografia className={classes.textoAnterior}>{evento.texto}</Tipografia>}
      {evento.dadosRemovidos && (
        <div className={classes.estiloCard}>
          {evento.dadosRemovidos.emails && (
            <div>
              <Tipografia tipo="notaLegendas" className={classes.texto}>
                <span className={classes.estiloCampo}> {intl.formatMessage({ defaultMessage: "E-mails" })}: </span>
                <span>{evento.dadosRemovidos.emails}</span>
              </Tipografia>
            </div>
          )}
          {evento.dadosRemovidos.telefones && (
            <div>
              <Tipografia tipo="notaLegendas" className={classes.texto}>
                <span className={classes.estiloCampo}>{intl.formatMessage({ defaultMessage: "Telefones" })}: </span>
                <span>{evento.dadosRemovidos.telefones}</span>
              </Tipografia>
            </div>
          )}
        </div>
      )}
    </Paper>
  );
};

TimeLineItemLogCadastro.propTypes = {
  evento: PropTypes.object,
  classes: PropTypes.object,
  index: PropTypes.number,
  isTimelineAtividades: PropTypes.bool,
};

export default withStyles(styles)(TimeLineItemLogCadastro);
